import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MxAlertService, MxBaseRestService } from 'mx-commons';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { getErrorMessageHttp } from 'src/app/shared/helpers/utils';
import { GenericValidator } from 'src/app/shared/services/generic-validator.service';
import { SaveService } from 'src/app/shared/services/save.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-modal-user-alterpassword',
  templateUrl: './modal-user-alterpassword.component.html',
  styleUrls: ['./modal-user-alterpassword.component.scss'],
})
export class ModalUserAlterPasswordComponent implements OnInit {
  formGroup: FormGroup;
  messageMatchPassword = { matchOther: () => 'As senhas não coincidem.' };
  passwordSecure: boolean;

  constructor(
    private readonly bsModalRef: BsModalRef,
    private readonly restService: MxBaseRestService,
    private readonly utilsService: UtilsService,
    private readonly alertService: MxAlertService,
    private readonly authService: SaveService,
    private readonly formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      passwordCurrent: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
        ]),
      ],
      password: [
        null,
        Validators.compose([
          Validators.required,
          this.createPasswordStrengthValidator(),
        ]),
      ],
      passwordRenew: [
        null,
        Validators.compose([
          Validators.required,
          GenericValidator.matchOtherValidator('password'),
        ]),
      ],
    });

    this.formGroup
      .get('password')
      .valueChanges.pipe()
      .subscribe((value: string) => {
        this.passwordSecure =
          /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
            value
          );
      });
  }

  createPasswordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const testStrength =
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          value
        );

      const passwordValid = testStrength;

      return !passwordValid ? { passwordStrength: true } : null;
    };
  }

  async save(): Promise<void> {
    try {
      if (this.formGroup.invalid) {
        this.alertService.warning(
          'Dados obrigatórios não informados ou inválidos!'
        );
        this.utilsService.validateAllFormFields(this.formGroup);
        return;
      }

      try {
        const { passwordCurrent, password } = this.formGroup.getRawValue();
        await this.restService
          .post('auth', 'changePassword', { passwordCurrent, password })
          .toPromise();
        this.alertService.success('Senha alterada com sucesso!');
      } catch (erro) {
        this.alertService.error(getErrorMessageHttp(erro));
        return;
      }

      this.close();
    } finally {
      this.authService.saving = false;
    }
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
